import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import dscRatings from "../../../../src/data/articles/cube-prospective-duskmourn-house-of-horror-commander/dsc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  dscRatings,
  ProspectiveIntro,
  React
};